import { Menu } from '@shared/components/Menu';
import { MBEmojiPicker } from '@shared/components/form';
import { grid } from '@shared/styles';
import { useIsDesktop } from '@shared/util/hooks';
import styles from './emojiButton.module.css';

interface Props {
  onSelect(emoji: string): void;
}

export function EmojiButton({ onSelect }: Props) {
  const isDesktop = useIsDesktop();

  if (!isDesktop) {
    return null;
  }
  return (
    <Menu>
      <Menu.Button
        variant="ghost"
        iconOnly
        icon="smile"
        iconSize={grid(5)}
        className={styles.emojiButton}
      />
      <Menu.Content className={styles.picker}>
        <MBEmojiPicker onSelect={onSelect} />
      </Menu.Content>
    </Menu>
  );
}
